import request from '@/utils/request'
import { downLoadZip } from '@/utils/zipdownload'

/** 获取平台 */
export function getDictList(params) {
  return request({
    url: `/api/dict/data/list?pageNum=1&pageSize=10&dictType=sys_notice_platform`,
    method: 'get',
    params
  })
}

// 查询班级列表
export function getClassList(params) {
  return request({
    url: `/api/class/page`,
    method: 'get',
    params
  })
}
/** ----------- 教学空间 ------------ */

// 获取教材信息
export function getBooksTypes() {
  return request({
    url: `/api/class/getBooks`,
    method: 'get'
  })
}

// 获取已有班级的教材
export function getClassBooks() {
  return request({
    url: '/api/class/getClassBooks',
    method: 'get'
  })
}

// 获取所有已发布图书的书名
export function getAllBooks() {
  return request({
    url: '/api/book/getAllBooks',
    method: 'get'
  })
}

// 获取消息内的所有已发布图书的书名
export function getAllMsgBooks() {
  return request({
    url: '/msg-notice/getAllBooks',
    method: 'get'
  })
}

// 获取教材信息,消息用
export function getMyShelfBooks() {
  return request({
    url: `/api/class/getMyShelfBooks`,
    method: 'get'
  })
}

// 删除班级
export function deleteClass(params) {
  return request({
    url: `/api/class/delete`,
    method: 'get',
    params
  })
}

// 新增班级
export function saveClass(data) {
  return request({
    url: `/api/class/save`,
    method: 'post',
    data
  })
}

// 修改班级
export function updateClass(data) {
  return request({
    url: `/api/class/update`,
    method: 'post',
    data
  })
}

// 判断是否激活教材
export function isOwnBook(params) {
  return request({
    url: `/api/class/isOwnBook`,
    method: 'get',
    params
  })
}

// 判断教材状态
export function isOwnBook2(params) {
  return request({
    url: '/api/class/isOwnBook2',
    method: 'get',
    params
  })
}

// 获取书本详情
export function getBookDetail(id) {
  return request({
    url: `/api/book/detail/${id}`,
    method: 'get'
  })
}


// 教学活动列表
export function getTeachActivity(params) {
  return request({
    url: `/teachActivity/getList`,
    method: 'get',
    params
  })
}

// 教学活动列表-复制
export function copyTeachActivity(data) {
  return request({
    url: `/teachActivity/copy`,
    method: 'post',
    data
  })
}

// 教学活动列表-删除
export function delTeachActivity(data) {
  return request({
    url: `/teachActivity/delete`,
    method: 'post',
    data
  })
}

// 教学活动列表-班级列表
export function getTeacherClass(params) {
  return request({
    url: `/homework/teacher/getClassList`,
    method: 'get',
    params
  })
}

/** ---------------入班学生明细-------------- */
// 退出班级
export function getStudentPage(params) {
  return request({
    url: `/api/class/student/page`,
    method: 'get',
    params
  })
}
// 审核学生
export function updateStudent(data) {
  return request({
    url: `/api/class/student/update`,
    method: 'post',
    data
  })
}

// 获取审核信息
export function getApprove(params) {
  return request({
    url: `/api/class/student/getApprove`,
    method: 'get',
    params
  })
}

// 批量审核
export function updateBatch(data) {
  return request({
    url: `/api/class/student/updateBatch`,
    method: 'post',
    data
  })
}

// 导出学生信息
export function exportStudent(data) {
  downLoadZip(`/api/class/student/export`, '学生信息', 'post', { exportType: '0', ...data })
}

/** ---------------我加入的班级-------------- */
// 退出班级
export function exitClass(params) {
  return request({
    url: `/api/class/student/exit`,
    method: 'get',
    params
  })
}

// 获取我的班级信息
export function getMyClass(data) {
  return request({
    url: `/api/class/student/myClass`,
    method: 'post',
    data
  })
}

// 加入班级
export function joinClass(data) {
  return request({
    url: `/api/class/student/join`,
    method: 'post',
    data
  })
}
// 加入班级
export function verifyCollege(params) {
  return request({
    url: `/api/class/student/verifyCollege`,
    method: 'get',
    params
  })
}

/** ---------------我的收藏-------------- */

// 取消收藏
export function bookCollectUpdate(data) {
  return request({
    url: `/api/bookCollect/update`,
    method: 'post',
    data
  })
}

// 查询收藏图书列表信息
export function getCollectPage(params) {
  return request({
    url: `/api/bookCollect/page`,
    method: 'get',
    params
  })
}

// 导出收藏图书信息
export function exportBookCollect(data) {
  downLoadZip(`/api/bookCollect/export`, '收藏图书', 'post', { exportType: '0', ...data })
}

/** ---------------购买记录-------------- */
// 购买记录列表
export function getPersonalOrder(params) {
  return request({
    url: `/api/personalOrder/myOrder`,
    method: 'get',
    params
  })
}

/** ---------------教材发放-------------- */
// 重新下载
export function exportCollegeBook(data) {
  return new Promise((resolve) => {
    downLoadZip(`/api/collegeBook/download`, '授权码', 'post', { exportType: '0', ...data }).finally(() => resolve())
  })
}

// 导出教材发放列表信息
export function exportMyBookAuthorize(data) {
  downLoadZip(`/api/collegeBook/exportMyBookAuthorize`, '教材发放', 'post', { exportType: '0', ...data })
}

// 获取授权列表信息
export function getCollegeBook(params) {
  return request({
    url: `/api/collegeBook/myBookAuthorize`,
    method: 'get',
    params
  })
}

/** ---------------使用帮助-------------- */
// 栏目卡片-列表
export function getTopicPage(params) {
  return request({
    url: `/api/help/topic/page`,
    method: 'get',
    params
  })
}

// 栏目详情-列表
export function getContentPage(params) {
  return request({
    url: `/api/help/content/page`,
    method: 'get',
    params
  })
}

/** ---------------我的反馈-------------- */
// 反馈列表
export function getFeedbackPage(params) {
  return request({
    url: `/api/member/feedback/page`,
    method: 'get',
    params
  })
}

// 纠错列表
export function getErrorFeedbackPage(params) {
  return request({
    url: `/api/error/feedback/page`,
    method: 'get',
    params
  })
}

// 新增反馈
export function feedbackAdd(data) {
  return request({
    url: `/api/member/feedback/add`,
    method: 'post',
    data
  })
}

/** ---------------院校教材-------------- */
// 教材列表
export function getMaterialsList(params) {
  return request({
    url: `/api/collegeBook/bookAuthorize`,
    method: "get",
    params,
  });
}

// 导出教材

export function exportMaterials(data) {
  return request({
    url: `/api/collegeBook/exportBookAuthorize`,
    method: "post",
    data,
    responseType: "blob",
  });
}

//授权设置详情

export function getAuthDetail(params) {
  return request({
    url: `/api/collegeBook/detail`,
    method: "get",
    params,
  });
}

// 授权设置列表
export function getAuthList(params) {
  return request({
    url: `/api/collegeBook/page`,
    method: "get",
    params,
  });
}


// 查询本校未授权人员信息
export function getTeacherList(params) {
  return request({
    url: `/api/collegeBook/getAuthorizeMember`,
    method: "get",
    params,
  });
}

// 新建授权
export function saveAuth(data) {
  return request({
    url: `/api/collegeBook/save`,
    method: "post",
    data,
  });
}

//编辑授权
export function editAuth(data) {
  return request({
    url: `/api/collegeBook/update`,
    method: "post",
    data,
  });
}

// 删除权限
export function delAuth(data) {
  return request({
    url: `/api/collegeBook/delete`,
    method: "post",
    data
  })
}


//获取剩余授权数量
export function getRelease(params) {
  return request({
    url: `/api/collegeBook/residueAuthorizeCount`,
    method: "get",
    params
  });
}

// 授权详情
export function getAuthContentDetail(params) {
  return request({
    url: `/api/collegeBook/detail`,
    method: "get",
    params,
  });
}

// 获取激活明细
export function getActiveDetail(params) {
  return request({
    url: `/api/collegeBookActiveCode/page`,
    method: "get",
    params,
  });
}

// 导出激活明细

export function exportActive(data) {
  return request({
    url: `/api/collegeBookActiveCode/export`,
    method: "post",
    data,
    responseType: "blob",
  });
}


// // 新增反馈
// export function feedbackAdd(data) {
//   return request({
//     url: `/api/member/feedback/add`,
//     method: 'post',
//     data
//   })
// }
/** ---------------院校信息-------------- */
// 查询订单列表信息
export function getCollegeOrder(params) {
  return request({
    url: `/api/collegeOrder/page`,
    method: 'get',
    params
  })
}

// 查询订单详细信息
export function getCollegeOrderDetail(params) {
  return request({
    url: `/api/collegeOrder/detail`,
    method: 'get',
    params
  })
}

// 查询订单图书列表信息
export function getCollegeOrderBook(params) {
  return request({
    url: `/api/collegeOrder/orderBook`,
    method: 'get',
    params
  })
}

// 查询院校用户信息
export function collegeUserListApi(params) {
  return request({
    url: `/api/collegeUser/page`,
    method: 'get',
    params
  })
}

// 绑定人员
export function saveCollegeUserApi(data) {
  return request({
    url: `/api/collegeUser/save`,
    method: 'post',
    data
  })
}

// 导出院校用户信息
export function exportCollegeUserApi(data) {
  downLoadZip(`/api/collegeUser/export`, '院校用户信息', 'post', { exportType: '0', ...data })
}

// 删除院校用户信息
export function deleteCollegeUserApi(data) {
  return request({
    url: `/api/collegeUser/delete`,
    method: 'post',
    data
  })
}

// 编辑绑定人员
export function updateCollegeUserApi(data) {
  return request({
    url: `/api/collegeUser/update`,
    method: 'post',
    data
  })
}

// 根据用户手机号获取用户姓名
export function getNameByPhoneApi(params) {
  return request({
    url: `/api/collegeUser/getNameByPhone`,
    method: 'get',
    params
  })
}

// 获取院校用户详情
export function collegeUserDetailApi(params) {
  return request({
    url: `/api/collegeUser/detail`,
    method: 'get',
    params
  })
}

// 获取院校信息
export function collegeDetail() {
  return request({
    url: `/api/college/detail`,
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/api/avatar',
    method: 'post',
    data: data
  })
}


// 修改用户个人信息
export function updateUserName(data) {
  return request({
    url: '/api/updateName',
    method: 'post',
    data: data
  })
}

// 录入学习数据
export function addRecord(data) {
  return request({
    url: '/api/myReport/record/add',
    method: 'post',
    data
  })
}

// 教材总览-图书列表
export function readBookList(params) {
  return request({
    url: '/api/myReport/read/book',
    method: 'get',
    params
  })
}

// 教材总览-阅读数量、阅读总时长、学习总时长
export function getBookTime() {
  return request({
    url: '/api/myReport/book/time',
    method: 'get'
  })
}

// 教材报告
export function bookReport(data) {
  return request({
    url: '/api/myReport/report',
    method: 'post',
    data
  })
}

// 班级信息
export function classReportDetail(params) {
  return request({
    url: '/api/classReport/detail',
    method: 'get',
    params
  })
}

// 资源情况
export function classReportResource(params) {
  return request({
    url: '/api/classReport/resource',
    method: 'get',
    params
  })
}

// 教学数据-教师工作量
export function teacherWork(params) {
  return request({
    url: '/api/classReport/teacher/work',
    method: 'get',
    params
  })
}

// 教学数据-班级学习数据
export function classLearn(params) {
  return request({
    url: '/api/classReport/class/learn',
    method: 'get',
    params
  })
}

// 教学活动轨迹
export function teacherActivity(data) {
  return request({
    url: '/api/classReport/teacher/activity',
    method: 'post',
    data
  })
}

// 学生学习数据
export function studentStudy(data) {
  return request({
    url: '/api/classReport/student/study',
    method: 'post',
    data
  })
}

export function batchAdd(data) {
  return request({
    url: '/api/myReport/record/batchAdd',
    method: 'post',
    data
  })
}

// 帮助详情统计
export function logPost(data) {
  return request({
    url: `/business/help/access/add`,
    method: "post",
    data,
  });
}

// 是否加入班级过
export function classHasJoint(params) {
  return request({
    url: '/api/class/student/hasJoint',
    method: 'get',
    params
  })
}

// 教材报告-导出
export function exportMyReport(data) {
  return new Promise((resolve) => {
    downLoadZip(`/api/myReport/report/export`, '', 'post', { exportType: '0', ...data }).finally(() => resolve())
  })
}

// 学生学习数据-导出
export function studentReport(data) {
  return new Promise((resolve) => {
    downLoadZip(`/api/classReport/student/study/export`, '', 'post', { exportType: '0', ...data }).finally(() => resolve())
  })
}

// 班级学习数据-导出
export function classReport(data) {
  return new Promise((resolve) => {
    downLoadZip(`/api/classReport/class/learn/export`, '', 'post', { exportType: '0', ...data }).finally(() => resolve())
  })
}

// 班级学习数据-按章-导出
export function classChapterReport(data) {
  return new Promise((resolve) => {
    downLoadZip(`/api/classReport/class/learn/chapter/export`, '', 'post', { exportType: '0', ...data }).finally(() => resolve())
  })
}

// 班级学习数据-按章
export function chapterClassReportApi(data) {
  return request({
    url: `/api/classReport/class/learn/chapter`,
    method: "post",
    data,
  });
}